import ProductIllustration from './ProductIllustration';
import styles from './ProductCard.module.css';

export default function ProductCard({ product }) {
  return (
    <article className={styles.card}>
      <div className={styles.dots} />

      <div className={styles.moduleBar}>
        <span>{product.module}</span>
        <span className={styles.moduleCode}>{product.code}</span>
      </div>

      <ProductIllustration productId={product.id} figure={product.figure} />

      <div className={styles.content}>
        <h2 className={styles.title}>{product.name}</h2>

        <div className={styles.meta}>
          {product.meta.map((row, i) => (
            <div
              key={row.key}
              className={`${styles.metaRow} ${i < product.meta.length - 1 ? styles.metaRowBorder : ''}`}
            >
              <span className={styles.metaKey}>{row.key}</span>
              <span className={styles.metaValue}>{row.value}</span>
            </div>
          ))}
        </div>

        <p className={styles.description}>{product.description}</p>

        <div className={styles.ctaWrapper}>
          <button className={styles.button} disabled title="Coming soon">
            <span>&gt; {product.action}</span>
            <span className={styles.cursor}>_</span>
          </button>
          <span className={styles.soon}>soon</span>
        </div>
      </div>
    </article>
  );
}
